import { render, staticRenderFns } from "./dfm-mobile-app.vue?vue&type=template&id=629fc01d"
import script from "./dfm-mobile-app.vue?vue&type=script&lang=js"
export * from "./dfm-mobile-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports